import { commonFilter } from './filter';

export default {
  pageName: 'Hashtag',
  pageId: '20104',
  pagePath: '/opinion/Stats/Hashtag',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
